import { render } from "./DatasetConsult.vue?vue&type=template&id=38f7b186"
import script from "./DatasetConsult.vue?vue&type=script&lang=js"
export * from "./DatasetConsult.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__